import { Button, Form, Modal, Input } from 'antd';
import { t } from 'i18next';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import IconRevise from '../../../../../assets/Images/icons/icon-revise';
import useNotify from '../../../../../context/Notification/useNotify';
import RopaService from '../../../../../services/Ropa.service';
import { ROUTER } from '../../../../../constants/router';

const ModalRevise = ({
    open,
    handelClose,
    getRoPaDetailHeader,
    status,
    setIsChangeStatus,
}) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    let { activityId } = useParams();
    const notify = useNotify();
    let navigate = useNavigate();

    const onFinish = async (values) => {
        setLoading(true);
        const payload = {
            activityId,
            status,
            lastReviewDate: null,
            nextReviewDue: null,
            ...values,
        };
        try {
            const { data } = await RopaService.changeStatusRopa(payload);
            if (data?.resultCode === 1) {
                setLoading(false);
                handelClose();
                getRoPaDetailHeader();
                setIsChangeStatus(true);
                notify({
                    title: t('common.Success'),
                    description: t('Successfully save data'),
                });
                navigate(`${ROUTER.DS_INVENTORY.ROPA}/${activityId}/view`);
            } else {
                setLoading(false);
                handelClose();
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submitted'),
                });
            }
            form.resetFields();
        } catch (error) {
            console.log(error);
            setLoading(false);
            handelClose();
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to submitted'),
            });
        }
    };

    return (
        <Modal
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
        >
            <div className="pt-8 pb-8">
                <div className="text-2xl font-semibold pb-12 text-center"></div>

                <div
                    className="text-4xl mb-6 "
                    style={{ color: '#A8A8AF', textAlign: 'center' }}
                >
                    <IconRevise />
                </div>
                <div className="text-2xl font-semibold pb-2 text-center ">
                    {t('Return to Revise Task')}
                </div>
                <div className=" pb-2 text-center text-[#65707A]">
                    {t('Do you want to return to revise task')}
                </div>
                <Form form={form} layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        name="reason"
                        rules={[
                            {
                                required: true,
                                message: t('dataFlow.ReasonIsRequired'),
                            },
                        ]}
                        label={t('Reason')}
                    >
                        <Input.TextArea
                            rows={4}
                            placeholder={t(
                                'Please include a message to notify the data owner'
                            )}
                            showCount
                            maxLength={500}
                        />
                    </Form.Item>

                    <div className="flex justify-center items-center space-x-4 pt-12">
                        <Button
                            className="w-36"
                            type="primary"
                            onClick={handelClose}
                            size="large"
                            ghost
                            htmlType="reset"
                        >
                            {t('common.Cancel')}
                        </Button>

                        <Button
                            className="w-36"
                            loading={loading}
                            size="large"
                            type="primary"
                            htmlType="submit"
                        >
                            {t('common.Submit')}
                        </Button>
                    </div>
                </Form>
            </div>
        </Modal>
    );
};
export default ModalRevise;
